import { render, staticRenderFns } from "./EnglishComponen.vue?vue&type=template&id=0aecd686&scoped=true"
import script from "./EnglishComponen.vue?vue&type=script&lang=js"
export * from "./EnglishComponen.vue?vue&type=script&lang=js"
import style0 from "./EnglishComponen.vue?vue&type=style&index=0&id=0aecd686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aecd686",
  null
  
)

export default component.exports